export const validLensIndexColumns = [
    {
        Header: "Index Value",
        accessor: "indexValue",
        canFilter: true,
        filterPlaceholder: "Filter by value",
        width: 150,
    },
    {
        Header: "Status",
        accessor: "status",
        canFilter: true,
        filterPlaceholder: "Filter by status",
        width: 100,
    },
    {
        Header: "Notes",
        accessor: "notes",
        width: 400,
    },
];
